var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAmbulancia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 71.4",
    style: {
      enableBackground: "new 0 0 85 71.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.086 -2.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.086 2.002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M55.1,13.4c0.5,0.5,1.4,0.5,1.9,0c3.4-3.4,3.4-8.9,0-12.4c-0.5-0.6-1.3-0.6-1.9-0.1c-0.6,0.5-0.6,1.3-0.1,1.9 C55,2.9,55,2.9,55.1,3c2.4,2.4,2.4,6.2,0,8.6c0,0,0,0,0,0C54.6,12.1,54.6,12.9,55.1,13.4C55.1,13.4,55.1,13.4,55.1,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M49.3,11.5c0.5,0.5,1.4,0.5,1.9,0c2.4-2.4,2.4-6.2,0-8.6c-0.6-0.5-1.4-0.4-1.9,0.1c-0.4,0.5-0.4,1.2,0,1.7 c1.3,1.3,1.3,3.4,0,4.8c0,0,0,0,0,0C48.8,10.2,48.8,11,49.3,11.5C49.3,11.5,49.3,11.5,49.3,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M24.6,13.7c0.7,0,1.3-0.6,1.3-1.4c0-0.3-0.1-0.7-0.4-0.9c-2.4-2.4-2.4-6.2,0-8.6c0,0,0,0,0,0 C26,2.3,26,1.5,25.4,1c-0.5-0.5-1.3-0.5-1.8,0c-3.4,3.4-3.4,8.9,0,12.4c0,0,0,0,0,0C23.9,13.6,24.2,13.7,24.6,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M30.4,11.8c0.7,0,1.3-0.6,1.3-1.3c0-0.3-0.1-0.7-0.4-0.9c-1.3-1.3-1.3-3.5,0-4.8c0.5-0.6,0.4-1.4-0.1-1.9 c-0.5-0.4-1.3-0.4-1.8,0c-2.4,2.4-2.4,6.2,0,8.6C29.7,11.7,30,11.8,30.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M77.6,39.2c-2-1.1-3.6-2.9-4.4-5.1l-4.1-10.5c-0.2-0.6-0.4-1.2-0.7-2.1c-1.3-4.4-6.1-5.5-8.3-5.4H46.9v-2.9 c0-3.6-2.9-6.6-6.6-6.6c-3.6,0-6.5,2.8-6.5,6.4c0,0,0,0.1,0,0.1v2.9H2.1c-0.8,0-1.4,0.6-1.4,1.4c0,0,0,0,0,0v43.7 c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0H6c1.4,5.7,7.2,9.2,13,7.8c3.9-1,6.9-4,7.8-7.8h26.5c1.4,5.7,7.2,9.3,12.9,7.8 c3.9-1,6.9-4,7.9-7.9h7.8c1.3,0,2.4-1.1,2.4-2.4v-9l0.1-2.6C84.4,44.9,82.1,41.7,77.6,39.2z M70.5,35.2c0.2,0.5,0.5,1,0.8,1.5 l-15.6,0.1L55.8,26h11.1c0,0,0.1,0,0.1,0L70.5,35.2z M36.6,13.2c0-2,1.6-3.7,3.6-3.7c0,0,0.1,0,0.1,0c2.1,0,3.8,1.7,3.8,3.7v2.9 h-7.5V13.2z M16.4,67.9c-4.4,0-8-3.5-8-8c0-4.4,3.5-8,8-8c4.4,0,8,3.5,8,8c0,0,0,0,0,0C24.3,64.4,20.8,67.9,16.4,67.9z M63.6,67.9 c-4.4,0-8-3.5-8-8c0-4.4,3.5-8,8-8c4.4,0,8,3.5,8,8c0,0,0,0,0,0C71.6,64.4,68,67.9,63.6,67.9z M74.4,59.7 c0-5.9-4.9-10.7-10.8-10.7c-5.9,0-10.7,4.9-10.7,10.8H27.1c0-5.9-4.8-10.8-10.8-10.8c-5.9,0-10.8,4.8-10.8,10.8H3.5V19h56.7 c0,0,4.5-0.1,5.6,3.7c0.1,0.2,0.1,0.4,0.2,0.5H55.8c-1.5-0.1-2.8,1.1-2.9,2.7v11c0.1,1.5,1.4,2.7,2.9,2.7h17.7 c0.8,0.8,1.8,1.6,2.8,2.2c2.5,1.4,5.4,3.7,5.3,6.8v0h-4.5c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h4.4l-0.1,8.4L74.4,59.7 L74.4,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M39.3,31.8h-4.6v-4.6c0-0.7-0.6-1.3-1.3-1.3l0,0H26c-0.7,0-1.3,0.6-1.3,1.3l0,0v4.6h-4.6 c-0.7,0-1.3,0.6-1.3,1.3l0,0v7.3c0,0.7,0.6,1.3,1.3,1.3h4.6v4.6c0,0.7,0.6,1.3,1.3,1.3h7.3c0.7,0,1.3-0.6,1.3-1.3v-4.6h4.6 c0.7,0,1.3-0.6,1.3-1.3v-7.3C40.6,32.4,40,31.8,39.3,31.8z M37.9,39.1h-4.6c-0.7,0-1.3,0.6-1.3,1.3V45h-4.6v-4.6 c0-0.7-0.6-1.3-1.3-1.3h-4.6v-4.6H26c0.7,0,1.3-0.6,1.3-1.3l0,0v-4.6H32v4.6c0,0.7,0.6,1.3,1.3,1.3l0,0h4.6V39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M63.8,56.1c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4C68.2,58.1,66.2,56.1,63.8,56.1z M63.8,62.2 c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7l0,0C65.5,61.5,64.7,62.2,63.8,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F4CA0"
    },
    d: "M15.6,56.1c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4C20,58.1,18,56.1,15.6,56.1z M15.6,62.2 c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C17.4,61.5,16.6,62.2,15.6,62.2C15.6,62.2,15.6,62.2,15.6,62.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAmbulancia);
export default __webpack_public_path__ + "static/media/iconoAmbulancia.e63df030.svg";
export { ForwardRef as ReactComponent };